/* SIVONTE · EMBER — site-wide behaviour
   Smooth scrolling, reveal-on-scroll, gold foil that follows the light, the burn bar, puffs of smoke,
   and the slide-out cart (adds to cart without leaving the page). */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.remove('no-js'); root.classList.add('js');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var SHOP = window.EMBER_SHOP || { money: '${{amount}}', cartUrl: '/cart', root: '/' };
  var E = window.EMBER = window.EMBER || {};

  /* ---------- smooth scrolling ---------- */
  var lenis = null;
  function startLenis() {
    if (reduce || !window.Lenis || lenis) return;
    lenis = new window.Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 0.95, anchors: { offset: -90 } });
    E.lenis = lenis;
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    var lock = function () {
      var b = document.body;
      var locked = root.classList.contains('ecart-open') || (b && (b.classList.contains('svn-locked') || b.classList.contains('ember-locked'))) || !!document.getElementById('sv-age-gate');
      if (locked) lenis.stop(); else lenis.start();
    };
    new MutationObserver(lock).observe(root, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(lock).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true });
    lock();
  }
  E.scrollTo = function (target, opts) {
    if (lenis) lenis.scrollTo(target, Object.assign({ duration: 1.1 }, opts || {}));
    else {
      var y = typeof target === 'number' ? target : (target.getBoundingClientRect().top + window.scrollY + ((opts && opts.offset) || 0));
      window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    }
  };
  if (window.Lenis) startLenis(); else window.addEventListener('load', startLenis);

  /* ---------- the gold foil catches the light ---------- */
  var fx = 0.5;
  if (!reduce) {
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      fx = e.clientX / window.innerWidth;
      root.style.setProperty('--foil-x', (12 + fx * 76).toFixed(1) + '%');
    }, { passive: true });
  }

  /* ---------- reveal on scroll ---------- */
  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var parts = n.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
          parts.forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span'); s.className = 'rw'; s.textContent = p; frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !/^(BR|SVG|IMG)$/.test(n.tagName)) walk(n);
      });
    };
    walk(el);
    $$('.rw', el).forEach(function (w, i) { w.style.setProperty('--i', i); });
  }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  E.reveal = function (scope) {
    $$('[data-reveal-words]', scope).forEach(splitWords);
    $$('[data-reveal], [data-reveal-words]', scope).forEach(function (el) {
      if (io && !reduce) io.observe(el); else el.classList.add('is-in');
    });
  };
  E.reveal(document);
  document.addEventListener('shopify:section:load', function (e) { E.reveal(e.target); });

  /* ---------- burn bar: the page burns down as you read ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var max = Math.max(1, root.scrollHeight - window.innerHeight);
      root.style.setProperty('--burn', (window.scrollY / max).toFixed(4));
      if (!fine && !reduce) root.style.setProperty('--foil-x', (20 + ((window.scrollY / 9) % 60)).toFixed(1) + '%');
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- puffs of smoke from anything marked data-puff ---------- */
  document.addEventListener('pointermove', function (e) {
    var el = e.target.closest && e.target.closest('[data-puff]');
    if (!el || !window.SMOKE) return;
    var now = performance.now();
    if (now - (el._puff || 0) < 70) return; el._puff = now;
    window.SMOKE.puffAt(e.clientX / window.innerWidth, 1 - e.clientY / window.innerHeight, 0.2);
  }, { passive: true });

  /* ---------- money ---------- */
  function money(cents) {
    var v = (cents || 0) / 100;
    var withSep = function (n, d, ts, ds) {
      var s = n.toFixed(d).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return s.join(ds);
    };
    return String(SHOP.money).replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withSep(v, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withSep(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withSep(v, 0, '.', ',');
      return withSep(v, 2, ',', '.');
    });
  }
  E.money = money;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var sized = function (url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };

  /* ---------- toast ---------- */
  var toastEl = null, toastT = 0;
  E.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'etoast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  };

  /* ---------- the cart drawer ---------- */
  var drawer = $('#ecart'), body = drawer && $('.ecart__body', drawer), foot = drawer && $('.ecart__foot', drawer), lastFocus = null, closeT = 0;
  function setCount(n) {
    $$('[data-svn-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
    $$('[data-svn-cart-count-text]').forEach(function (el) { el.textContent = '(' + n + ')'; });
    $$('[data-ecart-count]').forEach(function (el) { el.textContent = n; });
  }
  function render(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = '<div class="ecart__empty"><span class="orn" aria-hidden="true"><i></i></span><p>' + esc(drawer.dataset.empty || 'Your humidor is empty.') + '</p><a class="btn" href="' + esc(drawer.dataset.shop || '/collections/all') + '">' + esc(drawer.dataset.shopLabel || 'Choose a cigar') + '</a></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      var name = String(it.product_title || it.title).replace(/\s*\(.*\)\s*$/, '');
      var props = it.properties ? Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).map(function (k) { return esc(k) + ': ' + esc(it.properties[k]); }) : [];
      var meta = [];
      if (it.variant_title && it.variant_title !== 'Default Title') meta.push(esc(it.variant_title));
      meta = meta.concat(props);
      if (it.selling_plan_allocation) meta.push(esc(it.selling_plan_allocation.selling_plan.name));
      return '<div class="eline" style="animation-delay:' + (i * 50) + 'ms">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img class="eline__img" src="' + esc(sized(it.image, 200)) + '" alt="" loading="lazy" width="78" height="98">' : '<span class="eline__img"></span>') + '</a>' +
        '<div><p class="eline__name"><a href="' + esc(it.url) + '">' + esc(name) + '</a></p><span class="eline__price">' + esc(money(it.final_line_price)) + '</span>' + (meta.length ? '<p class="eline__meta">' + meta.join(' · ') + '</p>' : '') +
        '<div class="eline__row"><div class="qty" role="group" aria-label="Quantity for ' + esc(name) + '"><button type="button" data-ecart-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="One fewer">−</button><span>' + it.quantity + '</span><button type="button" data-ecart-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button></div>' +
        '<button type="button" class="eline__remove" data-ecart-qty="' + (i + 1) + '" data-q="0">Remove</button></div></div></div>';
    }).join('');
    $('[data-ecart-total]', drawer).textContent = money(cart.total_price);
  }
  function fetchCart() { return fetch(SHOP.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  E.refreshCart = function () { return fetchCart().then(function (c) { render(c); return c; }).catch(function () {}); };
  E.openCart = function () {
    if (!drawer) { window.location.href = SHOP.cartUrl; return; }
    clearTimeout(closeT);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    root.classList.add('ecart-open');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    E.refreshCart();
    setTimeout(function () { var x = $('.ecart__x', drawer); if (x) x.focus(); }, 80);
  };
  E.closeCart = function () {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    root.classList.remove('ecart-open');
    closeT = setTimeout(function () { drawer.hidden = true; }, 520);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-ecart-close]')) { E.closeCart(); return; }
      var q = e.target.closest('[data-ecart-qty]');
      if (!q) return;
      drawer.classList.add('is-busy');
      fetch(SHOP.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +q.dataset.ecartQty, quantity: Math.max(0, +q.dataset.q) }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items) { render(c); document.dispatchEvent(new CustomEvent('cart:update', { detail: c })); } else if (c && c.description) E.toast(c.description); })
        .catch(function () {}).then(function () { drawer.classList.remove('is-busy'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') E.closeCart(); });
  }
  /* cart icons open the drawer (except on the cart page itself) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !drawer || e.metaKey || e.ctrlKey || e.shiftKey || a.hasAttribute('data-ember-cart-page')) return;
    var href = a.getAttribute('href');
    if ((a.hasAttribute('data-ember-cart-open') || href === SHOP.cartUrl) && window.location.pathname !== SHOP.cartUrl) {
      e.preventDefault(); E.openCart();
    }
  });
  /* add to cart without leaving the page */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]') || form.hasAttribute('data-no-ajax') || !drawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]:not([name="checkout"])');
    if (btn) btn.classList.add('is-busy');
    fetch(SHOP.root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { E.toast(res.j.description || res.j.message || 'That could not be added.'); return; }
        document.dispatchEvent(new CustomEvent('cart:update', { detail: res.j }));
        if (window.SMOKE && btn) { var r = btn.getBoundingClientRect(); window.SMOKE.puffAt((r.left + r.width / 2) / window.innerWidth, 1 - r.top / window.innerHeight, 0.45); }
        E.openCart();
      })
      .catch(function () { form.setAttribute('data-no-ajax', ''); form.submit(); })
      .then(function () { if (btn) btn.classList.remove('is-busy'); });
  });
  document.addEventListener('cart:update', function () { setTimeout(function () { fetchCart().then(function (c) { setCount(c.item_count); }).catch(function () {}); }, 120); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) E.refreshCart(); });
})();
